import React, { Fragment, useEffect } from "react";
import Header from "../../components/Header/Header";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import SmsPageHero from "./components/SmsPageHero";
import SmsIntroSection from "./components/SmsIntroSection";
import SmsEdutechStats from "./components/SmsEdutechStats";
import SmsWhyWebsite from "./components/SmsWhyWebsite";
import SmsDeploymentTypes from "./components/SmsDeploymentTypes";
import SmsModulesSection from "./components/SmsModulesSection";
import WdevTestimonials from "../WebDevelopmentPage/components/WdevTestimonials";
import SmsCtaBanner from "./components/SmsCtaBanner";
import "../WebDevelopmentPage/web-development.css";
import "./school-management.css";

const SchoolManagementPage: React.FC = () => {
  useEffect(() => {
    document.title = "School Management System | WebTech Software Solutions Bangalore";
    const description =
      "WebTech develops server-based and mobile app school management software in Bangalore — student, parent, teacher, admin, and more modules in one platform.";
    let meta = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.name = "description";
      document.head.appendChild(meta);
    }
    meta.content = description;
  }, []);

  return (
    <Fragment>
      <div className="wdev-page inner-page sms-page">
        <div className="body_wrap o-clip">
          <Header />
          <main>
            <SmsPageHero />
            <SmsIntroSection />
            <SmsEdutechStats />
            <SmsWhyWebsite />
            <SmsDeploymentTypes />
            <SmsModulesSection />
            <WdevTestimonials />
            <SmsCtaBanner />
          </main>
          <Footer />
          <Scrollbar />
        </div>
      </div>
    </Fragment>
  );
};

export default SchoolManagementPage;
